<template>
    <div class="ProductListWrap">
        <div class="LineCut flexbetween">
            <div class="NewsTitle flexa"><p>GOEASY <span>CONNECT </span></p></div>
            <div class="Return flexa" @click="Return"><p>返回</p><img src="../../assets/Home/return.png"></div>
        </div>
<!--        <div class="From">
            <p>发布于 2020-07-27 17:45</p>
        </div>-->
        <div class="TabContentWrap clearfix">
            <div class="Title">
                <p>物流配送</p>
            </div>
            <ul>
                <li>
                    <div class="IconWrap">
                        <img src="../../assets/Home/l-3.jpg">
                        <div class="Name"><p>申通快递</p></div>
                        <div class="flexa Items"><span>#物流配送</span></div>
                    </div>
                    <div class="TextWrap">
                        <p class="fourline">申通快递品牌初创于1993年，公司致力于民族品牌的建设和发展，不断完善终端网络、中转运输网络和信息网络三网一体的立体运行体系，立足传统快递业务，全面进入电子商务领域，以专业的服务和 ...</p>
                    </div>
                </li>
                <li>
                    <div class="IconWrap">
                        <img src="../../assets/Home/l-4.jpg">
                        <div class="Name"><p>顺丰速运</p></div>
                        <div class="flexa Items"><span>#物流配送</span></div>
                    </div>
                    <div class="TextWrap">
                        <p class="fourline">1993年，顺丰诞生于广东顺德。自成立以来，顺丰始终专注于服务质量的提升，持续加强基础建设，积极研发和引进具有高科技含量的信息技术与设备以提升作业自动化水平，在国内外建立了庞大的信 ...</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="TabContentWrap clearfix">
            <div class="Title">
                <p>家居配套</p>
            </div>
            <ul>
                <li>
                    <div class="IconWrap">
                        <img src="../../assets/Home/l-5.jpg">
                        <div class="Name"><p>海尔 U-home</p></div>
                        <div class="flexa Items"><span>#智能家居</span></div>
                    </div>
                    <div class="TextWrap">
                        <p class="fourline">海尔智能家居是海尔集团在信息化时代推出的一个重要业务单元。它以U-home系统为平台，采用有线与无线网络相结合的方式，把所有设备通过信息传感设备与网络连接，从而实现了"家庭小网 "、"社区 ...</p>
                    </div>
                </li>
                <li>
                    <div class="IconWrap">
                        <img src="../../assets/Home/l-6.jpg">
                        <div class="Name"><p>诗派木门</p></div>
                        <div class="flexa Items"><span>#木门</span></div>
                    </div>
                    <div class="TextWrap">
                        <p class="fourline">诗派是永康市同泽工贸有限公司旗下一个品牌，集研发、制造、营销和配套服务为一体，产品涵盖室内门（强化生态木门，零度木门，全木门，实木门，钢木门），户外进户门（防盗门，非标别墅大门， ...</p>
                    </div>
                </li>
                <li>
                    <div class="IconWrap">
                        <img src="../../assets/Home/l-7.jpg">
                        <div class="Name"><p>翰府木门</p></div>
                        <div class="flexa Items"><span>#木门</span></div>
                    </div>
                    <div class="TextWrap">
                        <p class="fourline">翰府木门始终认为，要想长期发展下去，必须做好产品，产品质量不过硬的企业，不管如何大力营销，久而久之都会被淘汰。因此翰府木门引进先进环保的uv生产线等设备、通过iso9001:2000质量...</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'productlist',
    components: {},
    data() {
      return {
      };
    },
    methods: {
      Return() {
        this.$router.back();
      }
    }
  };
</script>
<style scoped lang="scss">
    @import '../../../public/Value';
    .ProductListWrap{
        width: 100%;
        .Title{
            width: 100%;
            margin: 0.1rem 0 0.15rem;
            border-bottom: 4px solid #666666;
            p{
                font-size: $AdditionTextSize;
                color: #fff;
                padding-bottom: 0.05rem;
            }
        }
        .LineCut{
            width: 88%;
            margin: 0.05rem auto 0.05rem;
            border-bottom: 2px solid #fff;
            .Return{
                cursor: pointer;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                }
                img{
                    width: 0.05rem;
                    margin-left: 0.02rem;
                }
            }
            .NewsTitle{
                p{
                    font-size: $TitleSize;
                    color: #fff;
                    padding-bottom: 0.045rem;
                    span{
                        opacity: 0.6;
                        font-weight: normal;
                    }
                }
            }
        }
        .From{
            width: 88%;
            margin: 0 auto 0.1rem;
            p{
                font-size: $TextSize;
                color: #fff;
                opacity: 0.6;
            }
        }
        .TabContentWrap{
            width: 88%;
            margin: 0 auto;
            ul{
                width: 100%;
                li{
                    width: 1.05rem;
                    height: 1.05rem;
                    background:linear-gradient(to right top,#9f9f9f,#cccccc);
                    border-radius: 0.1rem;
                    float: left;
                    margin-right: 2%;
                    margin-bottom: 2%;
                    position: relative;
                    cursor: pointer;
                    .TextWrap{
                        width: 82%;
                        margin: 0.1rem auto 0;
                        p{
                            font-size: $AdditionTextSize;
                            color: #414141;
                            line-height: 0.075rem;
                        }
                    }
                    .IconWrap{
                        margin: 0.1rem 0 0 0.1rem;
                        img{
                            width: 0.2rem;
                            border-radius: 0.03rem;
                        }
                        .Name{
                            margin: 0.05rem 0;
                            p{
                                font-size: $TextSize;
                                color: #000;
                                font-weight: bold;
                            }
                        }
                        .Items{
                            span{
                                font-size: $SmallTextSize;
                                color: #666666;
                                margin-right: 0.02rem;
                            }
                        }
                    }
                }
                li:nth-child(3n){
                    margin-right: 0;
                }
            }
        }
    }
</style>
